module.exports = new __parcel__URL__("earth_pulse.d75d8c78.png").toString();